// File: src/pages/student/StudentDashboard.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import logoImg from '../../assets/avt.png';

// Icons
const IconCompass = () => <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76" /></svg>;
const IconBookOpen = () => <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" /><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" /></svg>;
const IconRocket = () => <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z" /><path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z" /><path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0" /><path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5" /></svg>;
const IconBrain = () => <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9.5 2A2.5 2.5 0 0 1 12 4.5v15a2.5 2.5 0 0 1-4.96.44 2.5 2.5 0 0 1-2.96-3.08 3 3 0 0 1-.34-5.58 2.5 2.5 0 0 1 1.32-4.24 2.5 2.5 0 0 1 1.98-3A2.5 2.5 0 0 1 9.5 2Z" /><path d="M14.5 2A2.5 2.5 0 0 0 12 4.5v15a2.5 2.5 0 0 0 4.96.44 2.5 2.5 0 0 0 2.96-3.08 3 3 0 0 0 .34-5.58 2.5 2.5 0 0 0-1.32-4.24 2.5 2.5 0 0 0-1.98-3A2.5 2.5 0 0 0 14.5 2Z" /></svg>;

export default function StudentDashboard() {
    const navigate = useNavigate();

    const features = [
        {
            id: 'career-path',
            title: 'AI Hướng Nghiệp',
            subtitle: 'Nhập điểm số, sở thích để AI chọn trường & ngành phù hợp.',
            icon: <IconCompass />,
            color: 'from-pink-500 to-rose-500',
            bg: 'bg-pink-50',
            text: 'text-pink-600',
            link: '/student/career-path', // Link tới trang nhập liệu cũ
            badge: 'HOT'
        },
        {
            id: 'personality',
            title: 'Trắc nghiệm Tính cách',
            subtitle: 'Khám phá bản thân qua MBTI & Holland. Bạn là ai?',
            icon: <IconBrain />,
            color: 'from-purple-500 to-indigo-500',
            bg: 'bg-purple-50',
            text: 'text-purple-600',
            link: '/student/personality-test', // (Cần làm thêm trang này sau)
            badge: 'FREE'
        },
        {
            id: 'major-wiki',
            title: 'Từ điển Ngành học',
            subtitle: 'Ngành này học gì? Ra trường làm gì? Lương bao nhiêu?',
            icon: <IconBookOpen />,
            color: 'from-blue-500 to-cyan-500',
            bg: 'bg-blue-50',
            text: 'text-blue-600',
            link: '/student/major-wiki',
        },
        {
            id: 'skill-roadmap',
            title: 'Lộ trình Sinh viên',
            subtitle: 'Year-by-year roadmap cho SV Đại học để không thất nghiệp.',
            icon: <IconRocket />,
            color: 'from-orange-400 to-amber-500',
            bg: 'bg-orange-50',
            text: 'text-orange-600',
            link: '/student/uni-roadmap',
            badge: 'PRO'
        }
    ];

    return (
        <div className="student-dashboard">
            {/* DECORATION */}
            <div className="blob blob-1"></div>
            <div className="blob blob-2"></div>

            <div className="content-wrapper">
                <header className="header">
                    <div className="flex justify-center mb-6 " onClick={() => navigate('/')}>
                        <img
                            src={logoImg}
                            alt="SkillMatch Logo"
                            className="h-24 w-auto object-contain drop-shadow-md hover:scale-105 transition-transform cursor-pointer"
                        />
                    </div>
                    <h1 className="title">
                        Chào mừng đến <br />
                        <span className="highlight">Góc Học Tập Gen Z</span> 🚀
                    </h1>
                    <p className="subtitle">Khám phá bản thân, định hướng tương lai cùng AI Mentor.</p>
                </header>

                <div className="features-grid">
                    {features.map((feature) => (
                        <div
                            key={feature.id}
                            className="feature-card"
                            onClick={() => navigate(feature.link)}
                        >
                            <div className={`icon-wrapper ${feature.bg} ${feature.text}`}>
                                {feature.icon}
                            </div>
                            <div className="text-content">
                                <div className="card-header">
                                    <h3>{feature.title}</h3>
                                    {feature.badge && (
                                        <span className={`badge ${feature.badge === 'PRO' ? 'badge-pro' : 'badge-hot'}`}>
                                            {feature.badge}
                                        </span>
                                    )}
                                </div>
                                <p>{feature.subtitle}</p>
                            </div>
                            <div className={`hover-overlay bg-gradient-to-r ${feature.color}`}></div>
                        </div>
                    ))}
                </div>

                <div className="pro-banner">
                    <div className="pro-content">
                        <h3>🎓 Student Plus</h3>
                        <p>Mở khóa toàn bộ tính năng AI cao cấp chỉ với <strong>30k/tháng</strong></p>
                    </div>
                    <button className="pro-btn">Nâng cấp ngay</button>
                </div>
            </div>

            <style>{`
                .student-dashboard {
                    min-height: 100vh;
                    background-color: #F8FAFC;
                    padding: 50px 20px 40px;
                    font-family: 'Inter', sans-serif;
                    position: relative;
                    overflow: hidden;
                }
                
                /* BLOBS BACKGROUND */
                .blob { position: absolute; filter: blur(80px); opacity: 0.5; z-index: 0; border-radius: 50%; }
                .blob-1 { top: -100px; left: -100px; width: 500px; height: 500px; background: #FBCFE8; }
                .blob-2 { bottom: -100px; right: -100px; width: 600px; height: 600px; background: #C7D2FE; }

                .content-wrapper { max-width: 1000px; margin: 0 auto; position: relative; z-index: 10; }

                .header { text-align: center; margin-bottom: 60px; }
                .title { font-size: 3rem; font-weight: 900; color: #1E293B; margin-bottom: 16px; line-height: 1.2; }
                .highlight { background: linear-gradient(135deg, #DB2777, #7C3AED); -webkit-background-clip: text; -webkit-text-fill-color: transparent; }
                .subtitle { font-size: 1.2rem; color: #64748B; }

                /* GRID */
                .features-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(300px, 1fr)); gap: 24px; margin-bottom: 60px; }

                /* CARD */
                .feature-card {
                    background: white;
                    border-radius: 24px;
                    padding: 32px;
                    box-shadow: 0 10px 30px -10px rgba(0,0,0,0.05);
                    border: 1px solid #F1F5F9;
                    cursor: pointer;
                    position: relative;
                    overflow: hidden;
                    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
                    display: flex;
                    flex-direction: column;
                    gap: 20px;
                }
                .feature-card:hover {
                    transform: translateY(-8px);
                    box-shadow: 0 20px 40px -10px rgba(0,0,0,0.1);
                    border-color: transparent;
                }
                
                .icon-wrapper {
                    width: 70px; height: 70px;
                    border-radius: 20px;
                    display: flex; align-items: center; justify-content: center;
                    font-size: 1.5rem;
                    transition: transform 0.3s;
                }
                .feature-card:hover .icon-wrapper { transform: scale(1.1) rotate(5deg); }

                .card-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px; }
                .card-header h3 { font-size: 1.25rem; font-weight: 800; color: #334155; margin: 0; }
                
                .text-content p { color: #64748B; line-height: 1.5; font-size: 0.95rem; margin: 0; }

                .badge { font-size: 0.7rem; font-weight: 800; padding: 4px 8px; border-radius: 6px; letter-spacing: 0.5px; }
                .badge-hot { background: #FFE4E6; color: #E11D48; }
                .badge-pro { background: #FEF3C7; color: #D97706; }

                /* HOVER EFFECT */
                .hover-overlay {
                    position: absolute; bottom: 0; left: 0; width: 100%; height: 4px;
                    transition: height 0.3s;
                    z-index: -1;
                }
                .feature-card:hover .hover-overlay { height: 100%; opacity: 0.05; }

                /* BANNER */
                .pro-banner {
                    background: linear-gradient(135deg, #1E1E1E 0%, #312E81 100%);
                    border-radius: 20px;
                    padding: 30px 40px;
                    display: flex; justify-content: space-between; align-items: center;
                    color: white;
                    box-shadow: 0 20px 40px -10px rgba(49, 46, 129, 0.4);
                }
                .pro-content h3 { font-size: 1.5rem; font-weight: 800; margin: 0 0 4px; color: #FCD34D; }
                .pro-content p { margin: 0; opacity: 0.9; }
                .pro-btn {
                    background: #FCD34D; color: #312E81;
                    padding: 12px 24px; border-radius: 12px;
                    font-weight: 800; border: none; cursor: pointer;
                    transition: transform 0.2s;
                }
                .pro-btn:hover { transform: scale(1.05); background: #F59E0B; }

                @media (max-width: 768px) {
                    .title { font-size: 2rem; }
                    .pro-banner { flex-direction: column; text-align: center; gap: 20px; }
                }
            `}</style>
        </div>
    );
}